export const loadMoviesForDate = async (date: string): Promise<string[]> => {
    const response = await fetch('/data/october-2024.json');
    const data = await response.json();
    return data[date] || [];
  };